<template>
  <div class="banner">
    <div class="container">
      <div class="banner-row">
        <div>
          <h1 class="banner-title">{{ $t("title") }} {{ edition }}</h1>
          <h2 class="banner-subtitle">{{ $t("subtitle") }}</h2>
        </div>
        <img
          class="banner-logo"
          src="@/assets/img/logo_etat_fr.svg"
          :alt="$t('state_of_fribourg')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    edition: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.banner {
  padding: 15px 0;
  border-bottom: solid 2px #000;
}

.banner-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.banner-title {
  margin-right: 20px;
  line-height: 1.1;
  font-size: 30px;
  font-weight: 700;
  text-transform: uppercase;

  @media (min-width: 640px) {
    font-size: 40px;
  }
}

.banner-subtitle {
  line-height: 1.1;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;

  @media (min-width: 640px) {
    font-size: 25px;
  }
}

.banner-logo {
  width: 60px;
}
</style>
